import i18next, { getFixedT } from "i18next";
import { initReactI18next } from "react-i18next";
import enCommon from "../Strings/en/common.json";
import enPatients from "../Strings/en/patients.json";
import enProject from "../Strings/en/project.json";
import esCommon from "../Strings/es/common.json";
import esPatients from "../Strings/es/patients.json";
import esProject from "../Strings/es/project.json";
import LanguageDetector from "i18next-browser-languagedetector";
import { i18nCreateFakeLanguageResource, i18nFillOutEmptyValues, i18nGetWordAndStringCount } from "healthex-common/i18n.utils";
import { es } from "date-fns/locale";
import { observable } from "mobx";
const resources = {
    en: {
        common: i18nFillOutEmptyValues(enCommon),
        patients: i18nFillOutEmptyValues({ ...enCommon, ...enPatients }),
        project: i18nFillOutEmptyValues({ ...enCommon, ...enProject }),
    },
    es: {
        common: esCommon,
        patients: { ...esCommon, ...esPatients },
        project: { ...esCommon, ...esProject },
    },
};
export async function i18nSetLanguage(language) {
    console.debug(`[I18n] Setting language in i18next to: ${language}`);
    await i18next.changeLanguage(language);
}
const i18CurrentLanguageBox = observable.box(internalCurrentLanguage());
export function i18nGetCurrentLanguage() {
    return i18CurrentLanguageBox.get();
}
function internalCurrentLanguage() {
    var _a;
    return (_a = i18next.resolvedLanguage) !== null && _a !== void 0 ? _a : i18next.language;
}
export function getObservableT(ns) {
    let language = i18CurrentLanguageBox.get();
    let tFunc = getFixedT(language, ns);
    return (...args) => {
        if (language !== i18CurrentLanguageBox.get()) {
            language = i18CurrentLanguageBox.get();
            tFunc = getFixedT(language, ns);
        }
        return tFunc(...args);
    };
}
export function i18nGetDateFnsLocale() {
    const language = i18nGetCurrentLanguage();
    if (language.startsWith("es")) {
        return es;
    }
    return undefined;
}
export function i18nextInit() {
    void i18next
        .use(new LanguageDetector(null, { order: ["querystring", "navigator"], caches: [] }))
        .use(initReactI18next)
        .init({
        debug: true,
        ns: ["common", "patients", "project"],
        resources,
        fallbackLng: "en",
        returnEmptyString: false,
        react: {
            transSupportBasicHtmlNodes: true,
            transKeepBasicHtmlNodesFor: ["br", "b", "i", "strong", "em", "p"],
        },
    });
    if (i18next.language === "zz") {
        loadFakeLanguage();
    }
    i18next.on("languageChanged", (lng) => {
        console.log(`[I18n] Language changed: ${lng}`);
        i18CurrentLanguageBox.set(lng);
        if (lng === "zz") {
            loadFakeLanguage();
        }
    });
    getWordAndLineCount();
}
function loadFakeLanguage() {
    Object.entries(resources.en).forEach(([namespace, strings]) => {
        i18next.addResourceBundle("zz", namespace, i18nCreateFakeLanguageResource(strings));
    });
}
function getWordAndLineCount() {
    let totalWordCount = 0;
    let totalLineCount = 0;
    Object.entries(resources.en).forEach(([namespace, strings]) => {
        const { wordCount, lineCount } = i18nGetWordAndStringCount(strings);
        console.log(`[I18n] Namespace ${namespace} has ${lineCount} lines and ${wordCount} words`);
        totalWordCount += wordCount;
        totalLineCount += lineCount;
    });
    console.log(`[I18n] Total counts: ${totalLineCount} lines and ${totalWordCount} words`);
}
